import React, { VFC } from 'react';
import AppLayout from '../../../front/Layout/AppLayout';
import { HeaderProps } from '~/src/feature/Ambassador/types';
import Top from '~/src/feature/Ambassador/components/Top';
import Profiles from '~/src/feature/Ambassador/components/Profiles';
import styled from 'styled-components';
import { TEXT_COLOR } from '~/src/feature/Ambassador/constants';

const Container = styled.div`
  max-width: 960px;
  margin: 0 auto;
  color: ${TEXT_COLOR};
`;

interface Props {
  authenticated: boolean;
  headerProps: HeaderProps;
}

const AmbassadorComponent: VFC<Props> = ({ authenticated, headerProps }) => {
  return (
    <AppLayout authenticated={authenticated} {...headerProps}>
      <Container>
        <Top />
        <Profiles />
      </Container>
    </AppLayout>
  );
};

export default AmbassadorComponent;
